import type {Level} from 'shells/status-badge/status-badge';

import type {BulkEditStatus} from 'nutshell-graphql-types';

export function getBulkEditStatusInfo(status: BulkEditStatus):
    | {
          level: Level;
          text: string;
      }
    | null
    | undefined {
    switch (status) {
        case 'COMPLETED':
            return {level: 'success', text: 'Completed'};
        case 'QUEUED':
            return {level: 'info', text: 'Queued'};
        case 'IN_PROGRESS':
            return {level: 'info', text: 'In progress'};
        case 'ERRORED':
            return {level: 'alert', text: 'Errored'};
        default:
            return null;
    }
}
